import { BlogArticle, BlogArticleAdapter } from '@shared/models/blog-article.model';
import { BlogService, GhStorageService, TrackingService } from '@core/services';
import { Component, HostListener, Inject, OnInit, DOCUMENT } from '@angular/core';
import { environment } from '@env/environment';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { NewsletterDialogComponent, StickyBannerComponent } from '@shared/sections';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
    selector: 'gh-app-layout',
    templateUrl: 'app-layout.component.html',
    standalone: false
})
export class AppLayoutComponent implements OnInit {
  cdnPath = environment.cdnPath;
  popularArticles: BlogArticle[];
  isDrawerOpened = false;
  isBottomSheetOpened = false;
  dialogUnopened = true;
  envUrl = environment.website;
  root = environment.root;
  mainMenu;
  menuUS = [
    {
      page: 'why-gohenry/parents/', label: 'Why GoHenry',
      submenu: [
        { page: 'why-gohenry/parents/', label: 'For Parents & Kids' },
        { page: 'why-gohenry/teens/', label: 'For Teens' },
        { page: 'our-story/', label: 'Our Story' }
      ]
    },
    {
      page: 'why-gohenry/parents/', label: 'Debit Cards',
      submenu: [
        { page: 'kids-debit-card/', label: 'Debit Card for Kids' },
        { page: 'teen-debit-card/', label: 'Debit Card for Teens' },
        { page: 'personalised-debit-card/', label: 'Debit Card Designs' }
      ]
    },
    {
      page: 'learn/', label: 'Features',
      submenu: [
        { page: 'allowance-chores/', label: 'Allowance & Chores' },
        { page: 'saving/', label: 'Savings' },
        { page: 'parental-controls/', label: 'Parental Controls' },
        { page: 'learn/', label: 'Money Missions' },
        { page: 'why-gohenry/friends-and-family/', label: 'Giftlinks' }
      ]
    },
    {
      page: 'blog/allowance', label: 'Money Talk',
      submenu: [
        { page: 'blog/allowance', label: 'Allowance Tips' },
        { page: 'blog/chores', label: 'Chores Tips' },
        { page: 'blog/online-safety', label: 'Online Money Safety' },
        { page: 'blog/money-management', label: 'Money Management Tips' },
        { page: 'blog/financial-education', label: 'Financial Education Tips' },
        { page: 'blog/news', label: 'News' }
      ]
    }
  ];
  menuUK = [
    {
      page: 'why-gohenry/parents/', label: 'Why GoHenry',
      submenu: [
        { page: 'why-gohenry/parents/', label: 'For Parents & Kids' },
        { page: 'why-gohenry/teens/', label: 'For Teens' },
        { page: 'our-story/', label: 'Our Story' }
      ]
    },
    {
      page: 'why-gohenry/parents/', label: 'Debit Cards',
      submenu: [
        { page: 'kids-debit-card/', label: 'Debit Card for Kids' },
        { page: 'teen-debit-card/', label: 'Debit Card for Teens' },
        { page: 'personalised-debit-card/', label: 'Debit Card Designs' }
      ]
    },
    {
      page: 'learn/', label: 'Features',
      submenu: [
        { page: 'pocket-money-chores/', label: 'Pocket Money & Chores' },
        { page: 'saving/', label: 'Savings' },
        { page: 'parental-controls/', label: 'Parental Controls' },
        { page: 'learn/', label: 'Money Missions' },
        { page: 'why-gohenry/friends-and-family/', label: 'Giftlinks' },
        { page: 'junior-isa/', label: 'Junior ISA' }
      ]
    },
    {
      page: 'blog/allowance', label: 'Money Talk',
      submenu: [
        { page: 'blog/pocket-money', label: 'Pocket Money Tips' },
        { page: 'blog/chores', label: 'Chores Tips' },
        { page: 'blog/financial-education', label: 'Financial Education Tips' },
        { page: 'blog/online-safety', label: 'Online Money Safety' },
        { page: 'blog/family', label: 'Family Tips' },
        { page: 'blog/news', label: 'News' }
      ]
    }
  ];
  isUs = environment.locale === 'en-us';
  website = environment.website;
  webapp = environment.webapp;
  signup = environment.signup;
  support = environment.support;

  pageHeight = this.document.body.offsetHeight;
  header;
  bannerTrigger;

  private newsletterExpire = 7; // days

  constructor(
    public dialog: MatDialog,
    public bottomSheet: MatBottomSheet,
    @Inject(DOCUMENT) private document: Document,
    private blogArticleAdapter: BlogArticleAdapter,
    private blogService: BlogService,
    private location: Location,
    private storage: GhStorageService,
    private trackingService: TrackingService,
  ) { }

  ngOnInit() {

    this.isUs ? this.mainMenu = this.menuUS : this.mainMenu = this.menuUK;

    this.addBodyClassForRoute();
    // listener
    this.location.onUrlChange((url: string) => {
      this.addBodyClassForRoute(url);
    });
    this.getPopularArticles();
    this.header = this.document.getElementById('bgr-color');
    this.bannerTrigger = this.header.offsetHeight + this.header.offsetTop + 200;
    //this.detectReferralSource();
    //this.openStickyBanner();



    // Newsletter Popup is currently disabled

    // setTimeout(() => {
    //   this.openNewsletterDialog();
    // }, 3000);
    // setTimeout(() => {
    //   this.openStickyBanner();
    // }, 3000);
  }

  @HostListener('window:resize')
  onResize() {
    this.pageHeight = this.document.body.offsetHeight;
    this.bannerTrigger = this.header.offsetHeight + this.header.offsetTop + 200;
  }

  @HostListener('window:scroll')
  onScroll() {
    this.pageHeight = this.document.body.offsetHeight;
    const menu = this.document.getElementById("Menu");
    console.log(window.scrollY / this.pageHeight);
    if ((window.scrollY / this.pageHeight) >= 0.5 && this.dialogUnopened) {
      this.openNewsletterDialog();
    }

    if ((window.scrollY) >= this.bannerTrigger && !this.isBottomSheetOpened) {
      this.openStickyBanner();
      menu.style.transform = "translateY(-100%)"
    }
    if ((window.scrollY) < this.bannerTrigger && this.isBottomSheetOpened) {
      this.closeStickyBanner();
      menu.style.transform = "translateY(0)"
    }
  }

  toggleDrawer() {
    const el = this.document.body;
    if (el.offsetWidth <= 992) {
      this.isDrawerOpened = !this.isDrawerOpened;
      this.toggleDrawerCss();
    }
  }

  navClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'navigation',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }

  ctaClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'cta_click',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }

  toggleClick(button: Element) {
    if (button.slot == 'Log in') {
      this.trackingService.setDataLayerAttributes({
        event: 'interactionEvent',
        event_name: 'navigation',
        events: {
          click_text: button.slot,
          feature: 'blog',
          environment: environment.env,
          location
        }
      });
    } else {
      this.trackingService.setDataLayerAttributes({
        event: 'interactionEvent',
        event_name: 'cta_click',
        events: {
          click_text: button.slot,
          feature: 'blog',
          environment: environment.env,
          location
        }
      });
    }
  }

  swapButton() {
    const button = this.document.getElementById("menu-switch");

    if (window.scrollY > 5) {
      button.classList.add('swap');
      button.setAttribute('href', this.signup);
      button.setAttribute('slot', 'Start Free Trial');
      button.classList.add('btn-primary');
      button.classList.remove('btn-dark');
    } else {
      button.classList.remove('swap');
      button.setAttribute('href', this.webapp);
      button.setAttribute('slot', 'Log in');
      button.classList.add('btn-dark');
      button.classList.remove('btn-primary');
    }
  }

  private toggleDrawerCss() {
    const el = this.document.body;
    if (this.isDrawerOpened) {
      el.classList.add('drawer');
    } else {
      el.classList.remove('drawer');
    }
  }

  private addBodyClassForRoute(url = this.location.path()) {
    this.document.body.className = '';
    const segments = url.split(/\//); // 0 is " "
    if (segments.length === 2) {
      this.document.body.classList.add(segments[1].split('?')[0]);
    }
    if (segments.length === 3 && segments[1] !== 'author') {
      this.document.body.classList.add(segments[1]);
    }
  }

  private getPopularArticles() {
    this.blogService.getArticlesPopular()
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && !res.error) {
          const articles: BlogArticle[] = res;
          this.popularArticles = [];
          articles.forEach((article) => {
            this.popularArticles.push(this.blogArticleAdapter.adapt(article));
          });
        }
      });
  }

  private detectReferralSource() {
    const source = document.referrer;

    const searchEngines = [
      'google',
      'bing',
      'yahoo',
      'duckduckgo',
      'ecosia',
      'baidu',
      'yandex',
      'qwant',
      'gohenry'
    ]

    if (source) {
      for (let i = 0; i < searchEngines.length; i++) {
        if (source.includes(searchEngines[i])) {
          this.document.cookie = "promotion=ORGANICPROMO; path=/; domain=.gohenry.com";
        }
      }
    }
  }

  private openNewsletterDialog() {
    const date = new Date();
    date.setTime(date.getTime() + (this.newsletterExpire * 24 * 60 * 60 * 1000));
    const newsletterCookie = this.storage.getCookie('nwltr');
    this.dialogUnopened = false;
    // don't ask again for 30days
    if (newsletterCookie && +newsletterCookie < date.getTime()) {
      return;
    }
    this.dialog.open(NewsletterDialogComponent, {
      closeOnNavigation: true,
      maxWidth: '90vw',
      width: '800px',
      panelClass: 'newsletter-dialog',
      disableClose: true
    }).afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        const tick = new Date().getTime();
        this.storage.setCookie('nwltr', tick.toString(), date.toUTCString());
        console.log('CLOSED');
      });
  }

  private openStickyBanner() {
    this.isBottomSheetOpened = true;
    const scrollStrategy = new NoopScrollStrategy();
    this.bottomSheet.open(StickyBannerComponent, {
      hasBackdrop: false,
      scrollStrategy: scrollStrategy
    });
  }

  private closeStickyBanner() {
    this.isBottomSheetOpened = false;
    this.bottomSheet.dismiss(StickyBannerComponent);
  }

}
